export const siteConfig = {
  companyLegalName: "Mtaani",
  tradingName: "Mtaani",
  appName: "Rahisi",
  appTagline: "Your neighbourhood, delivered.",
  supportEmail: "mtaaniops@gmail.com",
  websiteDomain: "mtaani-ltd.vercel.app",
  jurisdiction: "Kenya",
  lastUpdated: "2026-02-17",
  playStoreUrl: "https://play.google.com/store/apps/details?id=com.xocan.Mtaaniv2",
};
